<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdRoutingMaintainResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" checkboxColumnDisabled
                                      with-custom-row-actions-first-column>
                                <template slot="left-header">
                                    <em-button type="search"
                                               v-if="pathType === 'todo'"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :customLabel="isClaim ? '认领' : '待办'"
                                               :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                               :busy="emWorkflowListLoading"
                                               show-name
                                               @click="switchClaim">
                                    </em-button>
                                </template>

                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <em-button type="task"
                                               :busy="claimLoading"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :custom-label="isClaim ? '认领' : '处理'"
                                               @click="handleExecute(customRowScope.row)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Lin
// Date 2022-05-06 20:09:47
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import ClaimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";

export default {
    name: "sithMesPrdRoutingMaintainWorkflowListView",
    mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi, ClaimTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItems"].join(",");
        },
    },
    watch: {
        pathType() {
            this.isClaim = false;
        }
    },
    data() {
        return {
            isClaim: false,
            claimLoading: false,
        }
    },
    methods: {
        handleExecute(row) {
            console.log(row)
            if (this.isClaim) {
                if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                    this.claimLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdRoutingMaintain/claimTask",
                        data: {
                            processDefinitionKey: row.workflowTask.processDefinitionKey,
                            businessKeyList: [row.id]
                        }
                    }).then(() => {
                        this.claimLoading = false;
                        this.$message.success("认领成功");
                        this.$_emWorkflowListMixin_init();
                    });
                }
            } else {
                this.$_emWorkflowListMixin_handleApprove(row);
            }
        },
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
    },
};
</script>